import { Box, Paper } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import TemplateEditor from "./TemplateEditor";
import TemplateEditorHeader from "./TemplateEditorHeader";
import { useSelector } from "react-redux";
import { selectEmployerTemplateState } from "../../../state/employerTemplate/employerTemplateSelector";
import { resetCreateEmployerTemplate, resetEditEmployerTemplate } from "../../../state/employerTemplate/employerTemplateSlice";

const CreateTemplateEditor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { template } = useSelector(selectEmployerTemplateState);
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const [docUrl, setDocUrl] = useState(null);
  const [editorValue, setEditorValue] = useState(template?.body ?? "");
  const [templateName, setName] = useState(template?.name ?? "");
  // const [isCreated, setIsCreated] = useState(!isEmpty(template?.id));
  const [isCreated, setIsCreated] = useState(false);
  const debounceTimeout = useRef(null);
  const editorValueRef = useRef(editorValue);
  editorValueRef.current = editorValue;

  // const getTemplatePdf = async (content) => {
  //     const file = await GeneratePdfDoc(content, template?.name);
  //     setDocUrl(URL.createObjectURL(file));
  // };

  const onUpdateTemplate = (name, content) => {
    setIsPdfGenerating(true);
    debounceTimeout.current = setTimeout(async () => {
      // getTemplatePdf(content);
      // const document = {
      //     name: name,
      //     subject: '--',
      //     body: content,
      //     type: type,
      // };
      // if (isCreated) {
      //     // document.id = template?.id ?? undefined;
      //     dispatch(editMessageTemplate(document));
      // } else {
      //     dispatch(createMessageTemplate(document));
      // }
      setIsPdfGenerating(false);
    }, 500);
  };

  const handleChange = (content) => {
    setEditorValue(content);
    // if (debounceTimeout.current) {
    //     clearTimeout(debounceTimeout.current);
    // }
    // onUpdateTemplate(templateName, content);
  };

  // useEffect(() => {
  //     if (isAddSuccess) {
  //         setIsCreated(true);
  //     }
  // }, [isAddSuccess]);

  useEffect(() => {
    return () => {
      dispatch(resetCreateEmployerTemplate());
      dispatch(resetEditEmployerTemplate());
    };
  }, []);
  return (
    <Paper elevation={0} sx={{ borderRadius: 3 }}>
      <Box sx={{ position: "fixed", top: 0, width: "100%", zIndex: 9999 }}>
        <TemplateEditorHeader
          isCreated={isCreated}
          isGenerating={isPdfGenerating}
          docUrl={docUrl}
          content={editorValue}
          templateName={templateName}
          setName={setName}
          onUpdateTemplate={onUpdateTemplate}
        />
      </Box>
      <TemplateEditor onChange={handleChange} value={editorValue} />
    </Paper>
  );
};

export default CreateTemplateEditor;
